import { Collapse } from "antd"
import { useGlobalContext } from "../../context/provider";


const FooterTablet = ({data}) => {

    const {theme} = useGlobalContext()

    const items = data.map((item,index)=>(
        {
            key:index,    
            label: <b className={`text-[16px] ${theme==="dark_theme"?'text-white':'text-black'}`}>{item.title}</b> ,
            children:
            item.items.map((data,key)=>
                <div key={key}>
                    {data.link ? ( 
                    <ul key={key} className="px-[5%]">
                        <a href={data.link}>&bull; {data.text} </a>
                    </ul>) : (
                        <ul key={key} className="px-[5%]">
                            <div className='' dangerouslySetInnerHTML={{__html:data.text}}></div>
                        </ul>
                    )}
                </div>
            )}
        )
    )
    return(
        <div className=" mx-[9%] py-[48px] mt-[1em] xl:mx-[15%]">
            <Collapse items={items} ghost  />
        </div>
    )
}

export default FooterTablet

